import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notice-press8',
  templateUrl: './notice-press8.component.html',
  styleUrls: ['./notice-press8.component.scss']
})
export class NoticePress8Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
